require("custom/qr-scanner-worker.min.js");